import {
  exam_createExamQuestionAnswer_Api,
  exam_deleteExamQuestionAnswer_Api,
  exam_editExamQuestionAnswer_Api,
  exam_sortExamQuestionAnswers_Api,
} from 'apis'
import _ from 'lodash'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import { useHistory } from 'modules/navigation/useRouter'
import { useState } from 'react'
import { showDeleteConfirmDialog } from 'views/AppLocals/factory/createConfirmDialog'
import { notifyOnError } from 'views/AppLocals/factory/createErrorEvent'
import {
  NotificationActionTypes,
  successNotify,
} from 'views/AppLocals/factory/createNotification'
import { bindQueryParam } from 'views/AppLocals/functions/routerHelper'

export const UseExamQA = ({
  children,
  question_id,
  refresh = ({ history }) => {},
  ...props
}) => {
  const t = useTranslate()

  const history = useHistory()

  const [refreshToken, setRefreshToken] = useState()

  const onError = notifyOnError(t)

  const reload = () => {
    setRefreshToken(Date.now())
    refresh({ history })
  }

  const { handleAsyncAction: onCreate } = useAsyncAction({
    onError,
    onSuccess: () => {
      successNotify(NotificationActionTypes.CREATE, t)
      reload()
    },
    query: bindQueryParam({ id: question_id }),
    apiInfo: exam_createExamQuestionAnswer_Api,
    ...props,
  })

  const { handleAsyncAction: onUpdate } = useAsyncAction({
    onError,
    onSuccess: () => {
      successNotify(NotificationActionTypes.UPDATE, t)
      reload()
    },
    apiInfo: exam_editExamQuestionAnswer_Api,
    ...props,
  })

  const { handleAsyncAction: onDelete } = useAsyncAction({
    onError,
    onSuccess: () => {
      successNotify(NotificationActionTypes.DELETE, t)
      reload()
    },
    apiInfo: exam_deleteExamQuestionAnswer_Api,
    ...props,
  })

  const { handleAsyncAction: sortAnswers } = useAsyncAction({
    onError,
    onSuccess: () => {
      successNotify(NotificationActionTypes.INFORMATION, t)
      reload()
    },
    query: bindQueryParam({ id: question_id }),
    apiInfo: exam_sortExamQuestionAnswers_Api,
    ...props,
  })

  return _.isFunction(children)
    ? children({
        onCreate,
        onUpdate,
        sortAnswers,
        onDelete: (values, query) => {
          showDeleteConfirmDialog({
            translate: t,
            title: 'delete answer',
            message: 'are you sure you want to delete it answer',
            onOk: () => {
              onDelete(values, query)
            },
          })
        },
        refreshToken,
      })
    : children || null
}
